import {
  type ExamTypeCategory,
  US_EXAM_TYPE_CATEGORY,
} from "$global-providers/rxdb-provider/collections/epocus-exam-worksheet-labels";
import {
  type ExamType,
  US_EXAM_TYPES,
  type UsExamType,
} from "../../../global-providers/rxdb-provider/collections/epocus-exam-worksheets";

const US_CATEGORY_COLORS: Record<
  Exclude<ExamTypeCategory, "procedures">,
  string
> = {
  emergency: "#EF4444",
  abdominal_renal: "#F59E0B",
  vascular: "#DC2626",
  msk_soft_tissue: "#0D9488",
  obstetric: "#DB2777",
};

const US_EXAM_COLORS = Object.fromEntries(
  US_EXAM_TYPES.map((examType) => [
    examType,
    US_CATEGORY_COLORS[US_EXAM_TYPE_CATEGORY[examType]],
  ]),
) as Record<UsExamType, string>;

export const EXAM_COLORS: Record<ExamType, string> = {
  efast: "#EF4444",
  cardiac: "#EC4899",
  lung: "#3B82F6",
  bladder: "#8B5CF6",
  renal: "#F59E0B",
  aorta: "#DC2626",
  pregnancy: "#DB2777",
  msk: "#0D9488",
  guided_joint_injection: "#0F766E",
  guided_tendon_injection: "#0E7490",
  guided_nerve_block: "#7C3AED",
  ...US_EXAM_COLORS,
};
